import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { FormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Subscription, Subject, map, of, filter, debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { HttpService } from '../../../shared/services/http.service';
import { JsonDataService } from '../../../shared/services/json-data.service';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'; 
import { SliceLoopPipe } from '../../../shared/pipes/slice-loop.pipe';
import { CarousalPageComponent } from "../../../shared/components/carousal-page/carousal-page.component";

@Component({
  selector: 'app-global-search',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatProgressSpinnerModule, CarousalPageComponent],
  templateUrl: './global-search.component.html',
  styleUrl: './global-search.component.scss',
  providers: [SliceLoopPipe] 
})
export class GlobalSearchComponent {
  environment: any = environment;
  recentlySearchList:any[] = [];
  sub:Subscription=new Subscription()
  public loading: boolean = false;
  public searchResults: any;
  public apiResponse: any;
  public searchTerm = new Subject<any>();
  public errorMsg: any;
  public noResult: boolean = false;
  formValue: any;



  customOptions: OwlOptions = {
    loop: true,

    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 600,
    nav: true,
    navText: ['', ''],
    stagePadding: 0,
    margin: 32,
    responsive: {
      0: {
        items: 2.5
      },
      400: {
        items: 2
      },
      768: {
        items: 4
      },
      1000: {
        items: 3.2
      },
    },
  };
  achievementData: any;
  searchTabs: any;

  public searchForm = new FormGroup({
    search: new FormControl('', [Validators.required, Validators.minLength(3)])
  })
  selectedFilter!: string;
  activeFilter: string = 'All';
  filteredProducts:any;
  filteredCategories:any;
  filteredCatalogues:any;
  constructor(@Inject(PLATFORM_ID) private platformId: Object,
  private http: HttpService, private analyticsService: AnalyticsService, private utils: UtilsService, private router: Router, private route: ActivatedRoute, private metaSvc: MetaMgmtService, private jsonDataService: JsonDataService,private sliceLoop: SliceLoopPipe) {
    this.utils.showHeaderFooter.next(true);
    this.sub.add(this.jsonDataService.getMetaDataJsonData().subscribe({
      next: (res: any) => {
        this.utils.hideLoading()
        const activeRouter = this.utils.getActiveRouter(this.router.url);
        const metaDataFilter = res.find((x: any) => activeRouter === x.name);
        let metaData = {
          canonicalURL: metaDataFilter?.canonicalUrl || '',
          description: metaDataFilter?.description || '',
          pageTitle: metaDataFilter?.title || '',
        };
        this.metaSvc.updateMetaTags(metaData);
      error: (err: any) => {
        this.utils.hideLoading()
        console.error('Error fetching meta data', err);
      }
    }}));
    this.getJsonData();
  }

  ngOnInit(): void {
    this.search();
    this.sub.add( this.utils.inputVal.subscribe(res => {
      this.formValue = res
    }))
    this.searchForm.setValue({
      search: this.formValue
    })
    
    if (this.formValue) {
      this.utils.showLoading();
      this.globalSearch(this.formValue);
      
    }
  
  }
  

  getJsonData() {
    this.sub.add(this.jsonDataService.getGlobalSearchJsonData().subscribe({
      next: (res: any) => {
        this.utils.hideLoading()
        this.achievementData = res.achievementData;
        this.searchTabs = res.searchTabs;
      },
      error: (err: any) => {
        this.utils.hideLoading()
      }
    }))
    
  }
  globalSearch(searchArgs: any) {
    this.utils.showLoading();
    this.sub.add(
      this.http.globalSearch(searchArgs).subscribe({
        next: (v) => {
          if (v.success) {
            this.loading = false;
            if (v.customerVideoSearchResponse && v.customerVideoSearchResponse.totalCount) {
              v.customerVideoSearchResponse.customerVideoSearchResponse.forEach((x: any) => {
                x['embededLink'] = x.link;
              });
            }
  
            // Store the response in a variable
            this.apiResponse = v;
            this.searchResults = v;
            
          
            // Facebook Pixel tracking
            if(isPlatformBrowser(this.platformId)) {  
              if ((window as any).fbq) {
                (window as any).fbq('track', 'Search');
              } else {
              }
            }
  
            // Check if results are available to update the noResult flag
            if (
              this.searchResults.customerCatalougesSearchResponse.totalCount > 0 ||
              this.searchResults.customerCategorySearchResponse.totalCount > 0 ||
              this.searchResults.customerProductSearchResponse.totalCount > 0 ||
              this.searchResults.customerVideoSearchResponse.totalCount > 0
            ) {
              this.searchProductEventTrigger(this.formValue, v.totalAllCount);
              this.noResult = false;
            } else {
              this.searchProductEventTrigger(this.formValue, v.totalAllCount);
              this.noResult = true;
            }
  
            // Update tab counts
            this.searchTabs.forEach((x: any) => {
              if (x.name === 'All') {
                this.searchTabs[0].totalCount = v.totalAllCount;
              } else if (x.name === 'Products') {
                this.searchTabs[1].totalCount = v.customerProductSearchResponse.totalCount;
              } else if (x.name === 'Categories') {
                this.searchTabs[2].totalCount = v.customerCategorySearchResponse.totalCount;
              } else if (x.name === 'Catalogue') {
                this.searchTabs[3].totalCount = v.customerCatalougesSearchResponse.totalCount;
              } else if (x.name === 'Videos') {
                this.searchTabs[5].totalCount = v.customerVideoSearchResponse.totalCount;
              }
            });
          }
          this.utils.hideLoading();
        },
        error: (e) => {
          this.utils.hideLoading();
        }
      })
    );
  }
  

  searchProductEventTrigger(keyword: string, count: number) {
    const data = {
      eventName: "Product Searched",
      eventData: {
        'Searched Keyword': keyword,
        'Item Count': count
      }
    };
    this.analyticsService.trackData(data);
   
    this.filteredProducts = this.sliceLoop.transform(this.apiResponse.customerProductSearchResponse?.customerProductSearchResponse || [], 3, this.activeFilter, 'Products');
    this.filteredCategories = this.sliceLoop.transform(this.apiResponse.customerCategorySearchResponse?.customerCategorySearchResponse || [], 4, this.activeFilter, 'Categories');
    this.filteredCatalogues = this.sliceLoop.transform(this.apiResponse.customerCatalougesSearchResponse?.customerCatalougesSearchResponse || [], 2, this.activeFilter, 'Catalogue');
  }

  filterTab(item: any) {
  this.activeFilter = item; 
  let allowed: any;
  this.loading = true;

  // Reset search results for 'All' case
  if (item === 'All') {
    this.searchResults = this.apiResponse;
    this.filteredProducts = this.sliceLoop.transform(this.apiResponse.customerProductSearchResponse?.customerProductSearchResponse || [], 3, this.activeFilter, 'Products');
    this.filteredCategories = this.sliceLoop.transform(this.apiResponse.customerCategorySearchResponse?.customerCategorySearchResponse || [], 4, this.activeFilter, 'Categories');
    this.filteredCatalogues = this.sliceLoop.transform(this.apiResponse.customerCatalougesSearchResponse?.customerCatalougesSearchResponse || [], 2, this.activeFilter, 'Catalogue');
    this.loading = false;
  } else {
    // Determine the allowed key for filtering
    if (item === 'Products') {
      this.selectedFilter = 'customerProductSearchResponse';
      allowed = 'customerProductSearchResponse';
      this.filteredProducts = this.sliceLoop.transform(this.apiResponse.customerProductSearchResponse?.customerProductSearchResponse || [], 3, this.activeFilter, 'Products');
    } else if (item === 'Categories') {
      this.selectedFilter = 'customerCategorySearchResponse';
      allowed = 'customerCategorySearchResponse';
      this.filteredCategories = this.sliceLoop.transform(this.apiResponse.customerCategorySearchResponse?.customerCategorySearchResponse || [], 4, this.activeFilter, 'Categories');
    } else if (item === 'Catalogue') {
      this.selectedFilter = 'customerCatalougesSearchResponse';
      allowed = 'customerCatalougesSearchResponse';
      this.filteredCatalogues = this.sliceLoop.transform(this.apiResponse.customerCatalougesSearchResponse?.customerCatalougesSearchResponse || [], 2, this.activeFilter, 'Catalogue');
    } else if (item === 'Videos') {
      this.selectedFilter = 'customerVideoSearchResponse';
      allowed = 'customerVideoSearchResponse';
    }

    // Only include allowed categories in searchResults
    this.searchResults = Object.keys(this.apiResponse)
      .filter(key => allowed?.includes(key))
      .reduce((obj, key) => {
        return {
          ...obj,
          [key]: this.apiResponse[key]
        };
      }, {});

    this.loading = false;
  }
}


  public search() {
    var searchArgs = '';
    this.sub.add( this.searchTerm.pipe(
      map((e: any) => {
        return e.target.value
      }),
      filter((e) => {
        if (e.length > 2) {
          return e
        }
      }),
      debounceTime(800),
      distinctUntilChanged(),
      switchMap(term => {
        searchArgs = term;
        this.loading = true;
        return this.http.globalSearch(term)
      })

    )
      .subscribe({
        next: (v) => {
          this.utils.hideLoading()
          this.loading = false;
          if (v.customerVideoSearchResponse && v.customerVideoSearchResponse.totalCount) {
            v.customerVideoSearchResponse.customerVideoSearchResponse.forEach((x: any) => {
              x['embededLink'] = x.link;
            })
          }
          this.apiResponse = v;
          this.filterTab(this.activeFilter)
          this.searchResults = v;
          if(isPlatformBrowser(this.platformId)) {  
            if ((window as any).fbq) {
              (window as any).fbq('track', 'Search');
            } else {
            }
          }
          // this.searchResults.wordPressAllPostDetailsResponse.totalCount > 0
          if (this.searchResults.customerCatalougesSearchResponse.totalCount > 0 || this.searchResults.customerCategorySearchResponse.totalCount > 0 || this.searchResults.customerProductSearchResponse.totalCount > 0 || this.searchResults.customerVideoSearchResponse.totalCount > 0) {
            this.searchProductEventTrigger(searchArgs, v.totalAllCount);
            this.noResult = false
          }

          else {
            this.searchProductEventTrigger(searchArgs, v.totalAllCount);
            this.noResult = true
          }

          this.searchTabs.forEach((x: any) => {
            if (x.name === 'All') {
              this.searchTabs[0].totalCount = v.totalAllCount
            }
            else if (x.name === 'Products') {
              this.searchTabs[1].totalCount = v.customerProductSearchResponse.totalCount
            }
            else if (x.name === 'Categories') {
              this.searchTabs[2].totalCount = v.customerCategorySearchResponse.totalCount
            }
            else if (x.name === 'Catalogue') {
              this.searchTabs[3].totalCount = v.customerCatalougesSearchResponse.totalCount
            }
            // else if (x.name === 'Blogs') {
            //   this.searchTabs[4].totalCount = v.wordPressAllPostDetailsResponse.totalCount
            // }
            else if (x.name === 'Videos') {
              this.searchTabs[5].totalCount = v.customerVideoSearchResponse.totalCount
            }
            else {
              return
            }
          })
        },
        error: (e) => {
          this.utils.hideLoading()
          this.loading = false;
          this.errorMsg = e;

        }

      }))
  }

  routeToProduct(guidId: string, productName: any) {
    if (isPlatformBrowser(this.platformId)) {

    localStorage.setItem('source', 'Others');
    let name: any = this.utils.createNameForUrl(productName)
    this.router.navigate(['product', name]);
  }
  }

  onHistorySelect(item: any) {
    this.searchForm.setValue({
      search: item,
    });
    this.globalSearch(item);
  }


  getRecentlySearched() {
    if (this.utils.getToken()) {
      this.sub.add( this.http.getRecentSearchedItems().subscribe((data: any) => {
        if (data.success) {
          this.recentlySearchList = data.searchedDetails;
          this.recentlySearchList.reverse();
        }
      }))
    }
  }

  categoryClickHandler(categoryData: any) {
    let catTitle = this.utils.createNameForUrl(categoryData.name);
    if (categoryData.type && categoryData.type.toLowerCase() == 'eshopcategory') {
      this.router.navigate(['product-listing', 'shop-now', this.utils.createNameForUrl(categoryData.name), categoryData.guidId])
    } else if (categoryData.type && categoryData.type.toLowerCase() == 'solarcategorylanding') {
      this.router.navigate([`category/solar/${catTitle}`])
    }
    else {
      this.router.navigate([`category/energy-storage/${catTitle}`])
    }
  }

  downloadCatalogue(url: string) {
    if(isPlatformBrowser(this.platformId)) {  
      window.open(url, '_blank');
    }
  }

  onImageError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = `${this.environment.blobUrl}/assets/images/product-placeholder.svg`;
  }

  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }
}
